module.exports = __webpack_public_path__ + "static/media/hea_syr.6cbaf216.png";